import CommonUtil from "utils/CommonUtil";
import {trackPromise} from "react-promise-tracker";

const menuRepository = new (class MenuRepository {
    /**
     * 전체 목록 조회
     *
     * @param menuKnd
     */
    public async readAllList(menuKnd: string): Promise<{
        "MENU_ID": string;
        "MENU_LEVEL": string;
        "MENU_NM": string;
        "MENU_PATH": string;
        "UPPER_MENU_ID": string;
        "AUTHOR_CODES": string;
    }[]> {
        return await trackPromise(
            CommonUtil.execute({
                url: 'com_menuAllList',
                data: {
                  MENU_KND: menuKnd
                }
            })
                .then((response: any) => {
                    // console.warn("MenuRepository","메뉴구조 하드코딩. 추후 변경 필요");
                    // if(menuKnd == "ADMIN")
                    //     return adminMenu.LIST
                    // if(menuKnd == "MAIN")
                    //     return mainMenu.LIST
                    return response.LIST;
                })
                .catch((error) => {
                    CommonUtil.showAxiosError(error);
                    return [];
                })
        );
    }
})();

export default menuRepository;
